<mat-dialog-content class="d-flex flex-column justify-content-between">
    <div class="d-flex justify-content-between align-items-center border-gray-bottom pb-3 mb-3">
        <h1 class="fw-bold fs-5 m-0">{{data.mainTitle !== '' ? data.mainTitle : 'Save Changes'}}</h1>
        <app-customicon name="round-close" (click)="closeDialog()"></app-customicon>
    </div>
    <div>
        <p class="text-gray fw-normal m-0">{{data.subTitle !== '' ? data.subTitle : 'Are you sure you want to save your changes?'}}</p>
    </div>
    <div class="d-flex gap-5 justify-content-end mt-5 pt-5">
        <!-- <button class="btn btn-primary-border" (click)="closeDialog()">Cancel</button> -->
        <app-button variant="outline" (buttonClick)="closeDialog()">Cancel</app-button>
        <!-- <button class="btn btn-primary" (click)="confirmDialog()">{{ data?.saveText || 'Confirm' }} </button> -->
        <app-button (buttonClick)="confirmDialog()">{{ data?.saveText || 'Confirm' }}</app-button>
    </div>
</mat-dialog-content>